import {Button} from '@priority-software/priority-style-react';
import {withTooltip} from '../../../components/Common/HOC/Custom/withTooltip';

export const ButtonWithToolTip = withTooltip(Button);
